import axios from "axios";
import { Component } from "react";
import { connect } from "react-redux";
import urls from "../urls";
import { setInitialOrderItems } from "../redux-state/features/orderState";
import ManagerTableRow from "./tableRow";
import _, { set } from "lodash";
import ChangePassWordModal from "../shared-components/changePassWordModal";
class ManagerHome extends Component {
  /**
   *
   */
  constructor() {
    super();
    this.state = {
      isLoading: false,
    };
    this.headerText = [
      "#",
      "المستخدم ",
      "البريد الإلكتروني",

      " تاريخ  الطلب",
      "طباعة الوصل",
      "",
    ];
  }
  componentDidMount() {
    this.setState({ isLoading: true });
    const { faculty_id } = this.props;
    axios
      .get(urls.getApprovedOrders, {
        params: {
          faculty_id,
        },
      })
      .then((res) => {
        const data = _.map(res.data, (obj) => ({
          ...obj,
          orderId: obj.order_id,
          status: obj.order_status,
        }));
        console.log("data : ", data);
        this.props.setInitialOrderItems(data);
        this.setState({ isLoading: false });
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        this.setState({ isLoading: false });
      });
  }
  render() {
    const { table_data } = this.props;
    const { isLoading } = this.state;
    return (
      <div>
        <ChangePassWordModal />
        <table className="table align-middle">
          <thead className="table-light text-center">
            <tr style={{ fontSize: "12px" }}>
              {this.headerText.map((txt, idx) => (
                <th key={"app-header" + idx}>{txt}</th>
              ))}
              <th></th>
            </tr>
          </thead>
          <tbody>
            {/* {table_data.map((obj, idx) => (
                    <ApplicationTableItem
                      orderNumber={idx + 1}
                      key={"ApplicationTableItem-" + idx}
                      obj={obj}
                    />
                  ))} */}
            {isLoading ? (
              <tr>
                <td colSpan={7} className=" text-center p-3">
                  <div
                    className="spinner-border text-primary"
                    style={{ width: "3rem", height: "3rem" }}
                    role="status"
                  >
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </td>
              </tr>
            ) : table_data.length === 0 ? (
              <tr>
                <td className=" text-center p-3" colSpan={7}>
                  لا توجد أي طلبات
                </td>
              </tr>
            ) : (
              table_data.map((obj, idx) => (
                <ManagerTableRow obj={obj} orderNumber={idx + 1} />
              ))
            )}
          </tbody>
        </table>
      </div>
    );
  }
}

const mapDispatchToProps = { setInitialOrderItems };
const mapStateToProps = (state) => ({
  table_data: state.orderState.orderData,
  faculty_id: state.userState.faculty_id,
});
export default connect(mapStateToProps, mapDispatchToProps)(ManagerHome);
